module.exports = __webpack_public_path__ + "static/media/MHHbanner.ac4c9054.jpg";